import {MODULE_TYPES} from '../../../constants';
import {hasModule} from "./ModuleUtil";

export const hasFeatureFlag = featureFlag => {
	const availableFeatureFlags = sessionStorage.getItem('availableFeatureFlags') ? JSON.parse(sessionStorage.getItem('availableFeatureFlags')) : [];

	if (!Array.isArray(availableFeatureFlags)) return false;

	if (availableFeatureFlags) {
		return availableFeatureFlags.some(flag => flag.key === featureFlag);
	} else {
		// eslint-disable-next-line no-console
		console.warn('No feature flags supplied to hasFeatureFlag');
		return false;
	}
};

export const setAvailableFeatureFlags = availableFeatureFlags => {
	if (Array.isArray(availableFeatureFlags)) sessionStorage.setItem('availableFeatureFlags', JSON.stringify(availableFeatureFlags));
};

export const hasTimeLocking = () => {
	return hasModule(MODULE_TYPES.TIME_LOCKING);
};

export const hasTimeApproval = () => {
	return hasModule(MODULE_TYPES.TIME_LOCKING);
};

export const usingTimeApproval = company => {
	return company.useTimeApproval && hasTimeApproval(company.modules);
};
